import type { ExamTypeConfig } from '@examflow/core';
import { registerExamQuestionTypes } from '@examflow/core';
import { JLPT_SECTIONS } from './sections';
import { jlptScoringRules } from './scoring';
import { JLPT_QUESTION_TYPE_DEFINITIONS } from './questionTypes';

/**
 * JLPT 考试完整配置
 */
export const jlptExamConfig: ExamTypeConfig = {
  id: 'jlpt',
  name: 'JLPT (Japanese Language Proficiency Test)',
  description: '日本语能力测试 - 国际通用的日语能力认证考试，分为 N5-N1 五个级别',
  languageId: 'japanese',
  questionTypeDefinitions: JLPT_QUESTION_TYPE_DEFINITIONS,
  sections: JLPT_SECTIONS,
  scoringRules: jlptScoringRules,
};

registerExamQuestionTypes('jlpt', Object.values(JLPT_QUESTION_TYPE_DEFINITIONS));

export * from './types';
export * from './sections';
export * from './scoring';
export * from './levels';
export * from './intro';
export * from './questionTypes';
